import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { IResponse } from '@bt/shared';
import { AssetBalanceModel } from '../models/AssetBalance.model';
import { BinanceWithdraw } from '../models';



@Injectable()
export class BinanceService {

  constructor(private api: ApiService) { }

  public uriBuilder(): string {
    return "api/binance";
  }

  public getAllBalances(): Promise<IResponse<AssetBalanceModel[]>> {
    return this.api.get<AssetBalanceModel[]>(this.uriBuilder() + "/getBalances").toPromise();
  }
  public getBinanceWithdraws(): Promise<IResponse<BinanceWithdraw[]>> {
    return this.api.get<BinanceWithdraw[]>(this.uriBuilder() + "/getBinanceWithdraws").toPromise();
  }

  public CreateWithdrawRequest(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(this.uriBuilder() + "/createWithdrawRequest").toPromise();
  }

  public checkWithdrawals(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>(this.uriBuilder() + "/checkWithdrawals").toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/binance.service.ts